module.exports = __webpack_public_path__ + "img/20.7fcf0134.png";